import { useCallback, useState } from "react"
import { createModel } from "hox"
import type { CategoryDetailVO } from "@/api"

function useStoreProfile() {
  const [storeProfile, set] = useState<CategoryDetailVO>()
  const [showStore, setShowStore] = useState(false)

  const setStoreProfile = useCallback(
    (value) => {
      set(value)
    },
    [set],
  )

  return { storeProfile, showStore, setStoreProfile, setShowStore }
}

export default createModel(useStoreProfile)
